import { useState } from "react";
import { message } from "antd";

import CatalogServices from "./../services/CatalogServices";


const useLocalidad = () => {
    const [catLocalidades, setCatLocalidades] = useState([]);
    const [loading, setLoading] = useState(false);

    const getLocalidades = async () => {
        setLoading(true);
        const services = await CatalogServices.getLocalidades();
        setLoading(false);
        const localidades = services.data.map((item) => ({ id: item.id_localidad, data: item.nombre_localidad }));
        setCatLocalidades(localidades);
    }

    const getLocalidadesByCP = async (codigo_postal) => {
        if (!codigo_postal) return;
        setLoading(true);
        const services = await CatalogServices.getLocalidadesByCP(codigo_postal);
        setLoading(false);
        const localidades = services.data.map((item) => (
            {
                id: item.id_localidad,
                data: item.nombre_localidad,
                municipio: item?.municipio?.nombre_municipio,
                estado: item?.municipio?.estado?.nombre_estado
            }
        ));
        if (!localidades?.length) {
            message.warning("No se encontraron localidades para este código postal.");
        }
        setCatLocalidades(localidades);
    }

    return { catLocalidades, loading, getLocalidades, getLocalidadesByCP };
};
export default useLocalidad;